import { useEffect } from 'react';
import { useCheckoutContext } from '@instamenu/context-checkout';
import { useUserContext } from '@instamenu/context-user';

/** Initialize loyalty: fetch program status (enrollment is handled by EnrollmentCard3D) */
export function useLoyaltyInit() {
  const checkout = useCheckoutContext();
  const loyalty = checkout?.loyalty;
  const { user } = useUserContext();

  useEffect(() => {
    if (!user || !loyalty) return;
    loyalty.checkProgram();
  }, [user, loyalty]);

  return { checkout, loyalty, user };
}
